module.exports = __webpack_public_path__ + "img/banner2.065369d0.png";